import React from 'react';
import styled from 'styled-components';

const TabSelector: React.FC<TabSelectorProps> = ({ onClick, selectedKey, tabs }) => (
	<Wrapper>
		<div>
			{tabs.map(({ key, label }) => (
				<Tab key={key} onClick={() => onClick(key)} isActive={selectedKey === key}>
					{label}
				</Tab>
			))}
		</div>
	</Wrapper>
);

export default TabSelector;

export interface TabSelectorProps {
	onClick: (key: string | number | undefined) => void;
	selectedKey: string | number | undefined;
	tabs: Array<{ key: string | number; label: string }>;
}

const Wrapper = styled.div`
	overflow-x: scroll;
	scrollbar-width: 0;
	border-bottom: 2px solid ${({ theme }) => theme.colors.primary};

	> div {
		display: flex;
	}
`;

const Tab = styled.button<{ isActive: boolean }>`
	flex-grow: 1;
	padding: ${({ theme }) => theme.spacings[3]} ${({ theme }) => theme.spacings[4]};
	font-size: ${({ theme }) => theme.fontSizes.sm};
	font-weight: 600;
	text-transform: uppercase;
	background-color: ${({ theme, isActive }) => (isActive ? theme.colors.primary : theme.colors.darkGrey)};
	color: ${({ theme, isActive }) => (isActive ? theme.colors.darkGrey : theme.colors.light)};

	&:hover {
		background-color: ${({ theme }) => theme.colors.primary};
		color: ${({ theme }) => theme.colors.darkGrey};
	}

	&:active,
	&:focus {
		outline: none;
	}
`;
